var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_150182",
    "data-name": "Group 150182",
    transform: "translate(-1727 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150096",
    "data-name": "Group 150096",
    transform: "translate(141 -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1586 24)",
    fill: "#f3f3f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150098",
    "data-name": "Group 150098",
    transform: "translate(1740.795 32.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102628",
    "data-name": "Path 102628",
    d: "M121.118,137h-.288l-.538,2.688h1.363Zm10.872,5.377a7.024,7.024,0,0,0,1.1,1.948,7.093,7.093,0,0,0,1.148-1.948Z",
    transform: "translate(-114.903 -130.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102629",
    "data-name": "Path 102629",
    d: "M252.714,91h-8.346l1.74,13.965a2.087,2.087,0,0,1-.5,1.53l-2.947,3.368h10.051a2.018,2.018,0,0,0,2.016-2.016V93.061A2.057,2.057,0,0,0,252.714,91Zm0,7.438h-.179a8.528,8.528,0,0,1-1.619,2.944c.494.451,1.022.822,1.547,1.236a.672.672,0,0,1-.84,1.049c-.57-.45-1.106-.827-1.641-1.318-.535.491-1.026.868-1.6,1.318a.672.672,0,0,1-.84-1.049c.525-.415,1.008-.785,1.5-1.236a8.482,8.482,0,0,1-1.574-2.944h-.179a.672.672,0,1,1,0-1.344h2.016v-.672a.672.672,0,0,1,1.344,0v.672h2.061a.672.672,0,1,1,0,1.344Z",
    transform: "translate(-231.791 -86.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102630",
    "data-name": "Path 102630",
    d: "M10.94,1.766A2.019,2.019,0,0,0,8.939,0H2.016A2.018,2.018,0,0,0,0,2.016V16.891a2.018,2.018,0,0,0,2.016,2.016h10.6c.2-.224.36-.364.367-.657,0-.073-2.033-16.412-2.042-16.484Zm-2.7,11.08a.672.672,0,0,1-.791-.527l-.43-2.148h-1.9l-.43,2.148a.672.672,0,1,1-1.318-.264L4.718,5.334a.673.673,0,0,1,.659-.54H6.766a.673.673,0,0,1,.659.54l1.344,6.721A.672.672,0,0,1,8.242,12.846Zm-.389,7.406.115.922A2.032,2.032,0,0,0,9.13,22.736l2.256-2.484Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/languageIcon.6206b9fdabf72d0b4ba96497686bcf79.svg";
export { ForwardRef as ReactComponent };